import { render, staticRenderFns } from "./LiveTab.vue?vue&type=template&id=680a414e"
import script from "./LiveTab.vue?vue&type=script&lang=js"
export * from "./LiveTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports